import React, { useCallback, useEffect, useReducer, useRef } from "react";
import IMenuItemBody from "../../../interfaces/IMenuItemBody";
import APIDefintions from '../../../yoello-lib/modules/API2/APIDefs';
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import { IVAT } from "../../../interfaces/IVat";
import ISubCategory from "../categories/ISubCategory";
import ICategory from "../categories/ICategory";
import "../../../css/menu.css";
import { ItemContainer } from "./ItemsContainer";
import { ProductContainerReducer } from "./state/productContainer.reducer";
import { setCategories, setDietaryTags, setExtraGroups, setIsLoading, setMenuItems, setPreferenceGroups, setSubCategories, setVAT, updateMenuItemPositions, updateSubcategoryPositions } from "./state/productContainer.action";
import { CategoriesContainer } from "./CategoriesContainer";
import { IExtraGroup } from "../../../interfaces/IExtraGroup";
import { ProductPage } from "./ProductPage/ProductPage";
import extrasColumns from "../../../columns/extras.columns";
import { ExtrasDialogForm } from "./ExtrasDialogForm";
import PreferenceFormComponent, { IPreference } from "../preferences/PreferenceForm";
import prefColumns from "../../../columns/preferences.columns";
import { useProductsData } from "./useProductsData";
import { ProductListSearchItem } from "./productList/ProductListSearchItem";
import { FaqLinks, getUrlBasedOnCurrentLanguage } from "../../../const/faqs-links";
import ExtraBulkAssign from "../products/extras/ExtraBulkAssign";
import { ManageMenuContainer } from "../../manageMenu/ManageMenuContainer";
import { Route, Switch } from "react-router-dom";
import { ADD_ITEM, BY_ID, dialogKeys, ITEMS, PRODUCTS_EXTRAS, PRODUCTS_ITEMS_URL, PRODUCTS_MANAGE_MENU_URL, PRODUCTS_PREFERENCE, PRODUCTS_SUBCATEGORIES } from "../../../const/URL.const";
import { ProductModifyDialog } from "./ProductModifyDialog";
import { AddExtrasFormDialog } from "./extras/ui/AddExtrasFormDialog";
import { TooltipContentMarkup } from "./extras/ui/TooltipContentMarkup";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { IMenuData } from "../../manageMenu/types";
import { MenuContainerTabs } from "../../Routes";
import { useTranslation } from "react-i18next";
import ListLoading from "../../util/Loading";
import {useStyles} from "./extras/styles";

export interface IProductsContainerState {
    categories: ICategory[];
    subcategories: ISubCategory[];
    vat: IVAT[];
    menuItems: IMenuItemBody[];
    isLoading: boolean;
    extraGroups: IExtraGroup[];
    preferences: IPreference[];
    tags: IItemTags[];
}
export const initalProductState = {
    categories: [],
    subcategories: [],
    vat: [],
    menuItems: [],
    isLoading: true,
    extraGroups: [],
    preferences: [],
    tags: [],
};
export function ProductsContainer() {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const [state, dispatch] = useReducer(ProductContainerReducer, initalProductState);
    const { t } = useTranslation();
    const classes = useStyles();
    const hasLoaded = useRef(false);
    /**Vat rates */
    const { isLoading: isLoadingVatData } = useProductsData<IVAT>(
        APIDefintions.vatRates, undefined, (item) => dispatch(setVAT(item)));
    /**Menu sub categories */
    const { callAPI: callSubcategory, isLoading: isLoadingSubCatData } = useProductsData<ISubCategory>(
        APIDefintions.menuItemSubcategories, selectedVenueId, (item) => dispatch(setSubCategories(item)), { 'sort_field': 'sort_position' });
    /**Menu  categories */
    const { isLoading: isLoadingCatData } = useProductsData<ICategory>(
        APIDefintions.menuItemCategories, undefined, (item) => dispatch(setCategories(item)));

    /**Menu Item data */
    const { callAPI: menuItemAPICall, isLoading: isLoadingMenuData } = useProductsData<IMenuItemBody>(
        APIDefintions.menusItems, selectedVenueId, (item) => dispatch(setMenuItems(item)), { 'sort_field': 'sort_position' });

    /**Extras groups data */
    const { callAPI: extraGroupAPICall, isLoading: extrasLoading } = useProductsData<IExtraGroup>(
        APIDefintions.extraGroups, selectedVenueId, (item) => dispatch(setExtraGroups(item)));

    /**Preference groups data */
    const { callAPI: preferenceAPICall, isLoading: prefenceLoading } = useProductsData<IPreference>(
        APIDefintions.menuItemPreferences, selectedVenueId, (item) => dispatch(setPreferenceGroups(item)));

    /**Dietary tags  data */
    useProductsData(
        APIDefintions.dietaryTags, undefined, (item) => dispatch(setDietaryTags(item)));

    /**Menus  */
    const { callAPI: manageMenuAPI } = useAPIV2<IMenuData | IMenuData[]>(APIExtensions.menus, {
        onMountDisabled: true,
        yoelloAPIParams: { venue_id: selectedVenueId, size: 200, include_disabled: true, },
        isPaginated: true,
    });
    /**Used for extras not used in the lists */
    const { callAPI: callExtraAPI } = useAPIV2<IExtraGroup>(APIDefintions.menuItemsExtraGroups, {
        onMountDisabled: true,
        yoelloAPIParams: { venue_id: selectedVenueId, size: 200, include_disabled: true, },
    })
    const { callAPI: searchMenuItems } = useAPIV2<IMenuItemBody[]>(APIDefintions.menuItemsSearch, {
        onMountDisabled: true,
    });


    const extrasFilter = useCallback(() => {
        return [{
            label: t("misc.subcategory"),
            optionLabelKey: "subcategory_name",
            optionFilterKey: "id",
            itemFilterKey: "subcategory_id",
            filterOptionsList:state.subcategories || [],
        }]
        // eslint-disable-next-line
    }, [state.subcategories]);

    useEffect(() => {
        const isLoadingLogic = (isLoadingMenuData || isLoadingCatData || isLoadingSubCatData || isLoadingVatData);
        if (isLoadingLogic) {
            dispatch(setIsLoading(true));
        } else {
            hasLoaded.current = true;
            dispatch(setIsLoading(false));
        }
        //eslint-disable-next-line
    }, [isLoadingMenuData, isLoadingCatData, isLoadingSubCatData, isLoadingVatData]);
    useEffect(() => {

    }, [state.categories, state.subcategories])

    function updateMenuItemPosition(itemPosition: string[]) {
        dispatch(updateMenuItemPositions(itemPosition));
    }
    function updateSubcategoryPosition(subcats: string[]) {
        dispatch(updateSubcategoryPositions(subcats));
    }

    const extrasProductPage = {
        getSearchLabelFunction: extraGroupsSearchFunction,
        createButtonLabel: "menu.extras.new",
        columns: extrasColumns,
        emptyListText: "menu.extras.emptyList",
        emptyListTextInfo: "menu.extras.emptyListInfo",
        renderOptionFunction: groupsRenderOption,
        faqLink:getUrlBasedOnCurrentLanguage(FaqLinks.EXTRAS.key),
        fieldList: [
            {
                key: "name_public",
            },
            {
                key: "quantity_min"
            },
            {
                key: "quantity_max"
            },
            {
                key: "",
                modifier: (field: string, card: any) => <ExtraBulkAssign card={card} menuItems={state.menuItems} filterOptions={extrasFilter}
                    callExtraAPI={callExtraAPI} searchMenuItems={searchMenuItems} />
            },

        ],
        buttonKey: "newExtraButton",
        tab: MenuContainerTabs.EXTRAS
    }

    const preferencesProductPage = {
        getSearchLabelFunction: preferencesSearchFunction,
        createButtonLabel: "preferences.newbutton",
        columns: prefColumns,
        emptyListText: "menu.preferences.emptyList",
        emptyListTextInfo: "menu.preferences.emptyListInfo",
        renderOptionFunction: groupsRenderOption,
        faqLink:getUrlBasedOnCurrentLanguage(FaqLinks.PREFERENCES.key),
        fieldList: [
            {
                key: "name_public",
            },

            {
                key: "preferences",
                modifier: (item: []) => item ? <div className={"coloredBackground"}>{item.length}</div> : 0,
            }],
        buttonKey: "newPrefButton",
        tab: MenuContainerTabs.PREFERENCES
    };

    const extrasPageProps = {
        ...extrasProductPage,
        dialogProps: {
            ...state,
            menuItemAPICall
        }
    }
    if (state.isLoading && !hasLoaded.current) return <ListLoading />;

    return <Switch>
        <Route path={PRODUCTS_SUBCATEGORIES}>
            <CategoriesContainer tab={MenuContainerTabs.SUBCATEGORIES}  {...state} updateSubcategoryPosition={updateSubcategoryPosition} venueId={selectedVenueId} callSubcategory={callSubcategory} />
        </Route>
        <Route path={PRODUCTS_ITEMS_URL}>
            <ItemContainer manageMenuAPI={manageMenuAPI} tab={MenuContainerTabs.ITEMS} menuItemAPICall={menuItemAPICall} {...state} updateMenuItemPosition={updateMenuItemPosition} venueId={selectedVenueId} />
        </Route>
        <Route path={PRODUCTS_EXTRAS}>
            <ProductPage {...extrasPageProps} itemDialogKey={dialogKeys.EXTRAGROUP}
                dialogRouteRows={[{
                    key: dialogKeys.EXTRAGROUP,
                    path: `${PRODUCTS_EXTRAS}${BY_ID}`,
                    exact: true,
                    Component: ExtrasDialogForm,
                    title: "menu.extras.title",
                    componentProps: {
                        ...state,
                        menuItemAPICall,
                        callAPI: extraGroupAPICall
                    }
                },
                {
                    key: dialogKeys.ASSIGNITEM,
                    path: `${PRODUCTS_EXTRAS}${BY_ID}${ADD_ITEM}`,
                    dialogClassName:classes.ModalContainer,
                    Component: AddExtrasFormDialog,
                    componentProps: {
                        menuItemAPICall,
                        APIDefinition: APIDefintions.menusItems,
                        toolTipContent: <TooltipContentMarkup />,
                        hasToolbar: false,
                        hasFilters: true,
                        hasFrame: false,
                        isVirtualizeList: true,
                        showTooltip: false,
                        nextKey: dialogKeys.ITEM,
                        nextURL: `${PRODUCTS_EXTRAS}${ITEMS}/`,
                        createButtonText: t("menu.extras.CreateNewProduct")
                    }
                },
                {
                    key: dialogKeys.ITEM,
                    path: `${PRODUCTS_EXTRAS}${ITEMS}${BY_ID}`,
                    Component: ProductModifyDialog,
                    title: "forms.modify.title",
                    componentProps: {
                        menuItemAPICall,
                        ...state,
                        removeAddToExtraGroup: true,
                        manageMenuAPI
                    }
                }
                ]}
                productList={state.extraGroups} isLoading={extrasLoading}
                venueId={selectedVenueId}
            />
        </Route>
        <Route path={PRODUCTS_PREFERENCE}>
            <ProductPage {...preferencesProductPage} productList={state.preferences} itemDialogKey="preferences"
                dialogRouteRows={[{
                    key: dialogKeys.PREFERENCE,
                    path: `${PRODUCTS_PREFERENCE}${BY_ID}`,
                    Component: PreferenceFormComponent,
                    title: "menu.preferences.title",
                    componentProps: {
                        callAPI: preferenceAPICall
                    }
                },
                ]}
                venueId={selectedVenueId} isLoading={prefenceLoading}
            />
        </Route>
        <Route path={PRODUCTS_MANAGE_MENU_URL}>
            <ManageMenuContainer subcategories={state.subcategories} menuItems={state.menuItems}
                venueId={selectedVenueId} isLoadingMenuData={isLoadingMenuData} tab={MenuContainerTabs.MANAGE_MENU}
            />
        </Route>
    </Switch>
}


function preferencesSearchFunction(preference: IPreference) {
    return preference.name_public;
}
function groupsRenderOption(extraGroup: IExtraGroup | IPreference) {
    return <ProductListSearchItem publicName={extraGroup.name_public} internalName={extraGroup.name_internal} />;
}
function extraGroupsSearchFunction(extraGroup: IExtraGroup) {
    return extraGroup.name_public;
}
